<template>
  <v-flex sm10 offset-sm1>
    <v-container fluid pt-5 mt-5>
      <v-flex>
        <v-card class="elevation-0">
          <v-flex md12 class="mb-3">
            <v-tabs centered color="#D5D5D5" show-arrows dark v-model="tab" class="rounded-tabs">
              <v-toolbar-title class="title">
                <div class="display-1 mt-3 mr-5 tamany_titol tw-txt-color-primary">{{ 'usermanager.title' | t }}</div>
              </v-toolbar-title>
              <v-tabs-slider color="primary ratlla"></v-tabs-slider>
            </v-tabs>
          </v-flex>
          <v-flex md6 ml-2 mr-2>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-flex>
          <v-data-table :headers="headers" :items="users" :pagination.sync="pagination" :search="search" :loading="loading" :rows-per-page-items="[100]" class="elevation-1">
            <template slot="headerCell" slot-scope="props">{{ props.header.text | t }}</template>
            <template slot="items" slot-scope="props">
              <tr @click="goUser(props.item.id)">
                <td class="text-xs-left">
                  <v-icon color="green" v-if="props.item.status === 1">check_circle</v-icon>
                  <v-icon color="grey" v-if="props.item.status === 0">history</v-icon>
                  <v-icon color="red" v-if="props.item.status === 2">block</v-icon>
                </td>
                <td class="text-xs-left">{{ props.item.id }}</td>
                <td class="text-xs-left">{{ props.item.mail }}</td>
                <td class="text-xs-left">{{ props.item.created_at }}</td>

                <td class="text-xs-left" v-if="props.item.w_digital >= 0">{{ props.item.w_digital }}</td>
                <td class="text-xs-left" v-else><b>0</b></td>
                <td class="text-xs-left" v-if="props.item.w_digital_limit >= 0">{{ props.item.w_digital_limit }}</td>
                <td class="text-xs-left" v-else><b>0</b></td>

                <td class="text-xs-left">{{ props.item.w_youtube }}</td>
                <td class="text-xs-left">{{ props.item.w_youtube_limit }}</td>

                <td class="text-xs-left">{{ props.item.w_instagram }}</td>
                <td class="text-xs-left">{{ props.item.w_instagram_limit }}</td>

                <td class="text-xs-left">{{ props.item.w_facebook }}</td>
                <td class="text-xs-left">{{ props.item.w_facebook_limit }}</td>

                <td class="text-xs-left">{{ props.item.w_twitter }}</td>
                <td class="text-xs-left">{{ props.item.w_twitter_limit }}</td>
              </tr>
            </template>
            <template slot="no-data">{{ 'billing.no_data' | t }}</template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-container>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['getTokenHeader', 'getServer'])
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'users_panel.status.title', value: 'status', sortable: true },
        { text: 'users_panel.id', value: 'id', sortable: true },
        { text: 'users_panel.mail', value: 'mail', sortable: true },
        { text: 'users_panel.created_at', value: 'created_at', sortable: true },
        {
          text: 'users_panel.activeworkersdigital',
          value: 'w_digital',
          sortable: true
        },
        {
          text: 'users_panel.activeworkersdigitalmax',
          value: 'w_digital_limit',
          sortable: true
        },

        {
          text: 'users_panel.activeworkersyoutube',
          value: 'w_youtube',
          sortable: true
        },
        {
          text: 'users_panel.activeworkersyoutubemax',
          value: 'w_youtube_limit',
          sortable: true
        },

        {
          text: 'users_panel.activeworkersinstagram',
          value: 'w_instagram',
          sortable: true
        },
        {
          text: 'users_panel.activeworkersinstagrammax',
          value: 'w_instagram_limit',
          sortable: true
        },

        {
          text: 'users_panel.activeworkersfacebook',
          value: 'w_facebook',
          sortable: true
        },
        {
          text: 'users_panel.activeworkersfacebookmax',
          value: 'w_facebook_limit',
          sortable: true
        },

        {
          text: 'users_panel.activeworkerstwitter',
          value: 'w_twitter',
          sortable: true
        },
        {
          text: 'users_panel.activeworkerstwittermax',
          value: 'w_twitter_limit',
          sortable: true
        }
      ],
      users: [],
      totalRows: 0,
      loading: false,
      pagination: {},
      selected: [],
      currentSort: 'id',
      currentSortDir: 'desc'
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getData()
      }
    }
  },
  methods: {
    ...mapActions(['rmKey']),
    async getData() {
      this.loading = true
      const data = await this.$http.get(`${this.getServer}/users/manager?page=0`, this.getTokenHeader)

      if (data.data && data.data.users && data.data.totalRows) {
        if (Array.isArray(data.data.users)) this.users = data.data.users
        this.totalRows = data.data.totalRows
      }
      this.loading = false
    },
    goUser(id) {
      this.$router.push({ path: `/usereditor/${id}` })
    }
  }
}
</script>
<style scoped>
.rounded-tabs {
  border-radius: 6px !important;
}
.rounded-tabs-sub {
  border-radius: 6px !important;
}
.tamany_titol {
  font-size: 28px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.tamany_titol_sitebar {
  font-size: 18px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.ratlla {
  height: 3px !important;
}
.subtitol {
  padding-top: 8px !important;
  padding-left: 20px !important;
  background-color: #f2f2f2 !important;
  padding-bottom: 6px !important;
}
.nobot {
  padding-bottom: 0px !important;
}
.background {
  /*background-color: rgb(241 85 80 / 15%) !important;*/
  background: linear-gradient(to bottom, rgb(241 85 80 / 15%), #ffffff) !important; /* De rojo a blanco */
}
.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
